<template>
  <div class="ds-control dsf-sc-table-design dsf-sc-biaofulu" :class="getCss" @click="click">
    <img :src="'./static/img/project/tableDesign/biaofulu.jpg'" />
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCBiaofulu",
  ctrlCaption: "表附录",
  mixins: [$mixins.control],
  props: {
    // 统计范围
    tjfw: {
      type: Boolean,
      default: true,
    },
    // 报送日期及方式
    bsrqjfs: {
      type: Boolean,
      default: true,
    },
    // 审核关系
    shgx: {
      type: Boolean,
      default: true,
    },
    // 其他文本数据
    qtwbsj: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    click() {
      dsf.layer.openDialog()
    },
  },
});
</script>

<style></style>
